import { AddItemButton } from '@core/components/Buttons';
import { CurrencyTextField } from '@core/components/Inputs';
import { Grid, IconButton, makeStyles, Tooltip, Typography } from '@material-ui/core';
import { SelectCategoria } from 'app/components/Select';
import { confirmarAlert } from 'app/services/alerts';
import { getCurrency } from 'app/utils/monetarioUtil';
import clsx from 'clsx';
import { FieldArray } from 'formik';
import React, { Fragment } from 'react';
import { MdHighlightOff } from 'react-icons/md';

const styles = makeStyles({
  diferencaParcelas: {
    fontSize: 15,
    fontWeight: 500,
    color: '#f00',
  },
  buttonAdicionarCategoria: {
    paddingTop: '0px !important',
    paddingLeft: '4px !important',
    // paddingBottom: '0px !important',
  },
  buttonRemoveContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
});

const Categorias = ({
  categorias = [{ id: undefined, classe: {}, valorBruto: undefined }],
  handleChange,
  handleChangeValorBruto,
  handleBlur,
  disabledClasse,
  disabledValor,
  errors,
  natureza,
  showDiferenca = false,
  diferencaCategorias = 0,
  limitarCategorias = false,
  showAlertRetencao = false,
  origemIntegracao,
}) => {
  const classes = styles();

  const handleAdicionarCategoria = (categorias) => {
    const event = {
      target: {
        id: `categorias[${categorias.length}]`,
        value: {},
      },
    };

    if (showAlertRetencao && categorias.length === 1) {
      confirmarAlert({
        confirmar: () => {
          handleChange(event);
        },
        titulo: 'Ao informar mais de uma categoria, não será possível informar retenção.',
        mensagem: 'Deseja continuar?',
      });
    } else {
      handleChange(event);
    }
  };

  return (
    <>
      <FieldArray name="categorias">
        {(arrayHelpers) =>
          categorias.map((categoria, index) => {
            const primeiroIndex = index === 0;
            return (
              <Fragment key={index}>
                <Grid item xs={12} sm={12} md={7} lg={7} xl={7}>
                  <SelectCategoria
                    id={`categorias[${index}].classe`}
                    label="Categoria"
                    value={categoria.classe}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    maxLength={100}
                    natureza={natureza}
                    required
                    error={errors?.categorias && errors?.categorias[index]?.classe}
                    touched={!!errors?.categorias && !!errors?.categorias[index]?.classe}
                    disabled={disabledClasse || origemIntegracao}
                  />
                </Grid>
                {!limitarCategorias ? (
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={primeiroIndex ? 5 : 4}
                    lg={primeiroIndex ? 5 : 4}
                    xl={primeiroIndex ? 5 : 4}
                  >
                    <CurrencyTextField
                      id={`categorias[${index}].valorBruto`}
                      name={`categorias[${index}].valorBruto`}
                      value={categoria.valorBruto}
                      outputFormat="number"
                      decimalCharacter=","
                      digitGroupSeparator="."
                      maximumValue="999999999"
                      minimumValue="0"
                      decimalPlaces={2}
                      decimalPlacesShownOnBlur={2}
                      decimalPlacesShownOnFocus={2}
                      onChange={(e, value) => {
                        const event = {
                          target: {
                            id: e.target.id,
                            value: e.target.value === '' ? '' : value,
                          },
                        };
                        handleChangeValorBruto(event, index);
                      }}
                      onBlur={handleBlur}
                      fullWidth
                      variant="outlined"
                      label="Valor (R$)"
                      required
                      error={errors?.categorias && errors?.categorias[index]?.valorBruto}
                      helperText={errors?.categorias && errors?.categorias[index]?.valorBruto}
                      touched={!!errors?.categorias && !!errors?.categorias[index]?.valorBruto}
                      currencySymbol=""
                      disabled={disabledValor}
                    />
                  </Grid>
                ) : null}

                {!primeiroIndex && !disabledClasse && !disabledValor && (
                  <Grid item xs={1} className={classes.buttonRemoveContainer}>
                    <Tooltip title="Excluir categoria" placement="right-end">
                      <Grid item style={{ justifyContent: 'center', alignContent: 'center' }}>
                        <IconButton
                          onClick={(e) => {
                            arrayHelpers.remove(index);
                            handleChangeValorBruto(e, index);
                          }}
                        >
                          <MdHighlightOff size={18} />
                        </IconButton>
                      </Grid>
                    </Tooltip>
                  </Grid>
                )}
              </Fragment>
            );
          })
        }
      </FieldArray>

      {!limitarCategorias && !disabledClasse && !disabledValor
        ? categorias.length < 5 && (
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.buttonAdicionarCategoria}>
              <AddItemButton
                onClick={() => {
                  handleAdicionarCategoria(categorias);
                }}
              >
                Adicionar categoria
              </AddItemButton>
            </Grid>
          )
        : null}

      {showDiferenca && !!diferencaCategorias && (
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography className={clsx(classes.diferencaParcelas)}>
            Diferença: {getCurrency(diferencaCategorias)}
          </Typography>
        </Grid>
      )}
    </>
  );
};

export default Categorias;
